/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import '../../css/pages/home.css';
import { toast } from 'react-toastify';
import { Bar, Line, Pie } from 'react-chartjs-2';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import AxiosClient from '../utils/AxiosClient';

class Analysis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loanAmount: [],
      loanCount: [],
      analysisYear: [],
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  }

  componentDidMount() {
    // this.loanAmount();
    const currentYear = new Date().getFullYear();
    this.showYears();
    this.fetchReport(currentYear);
    this.fetchReportPie(currentYear);
  }

    getChartData = (labelData, labelName, labelTitle) => {
      const data = {
        labels: labelName,
        datasets: [
          {
            label: labelTitle,
            data: labelData,
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(255, 159, 64, 0.2)',
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
              'rgba(153, 102, 255, 1)',
              'rgba(255, 159, 64, 1)',
            ],
            borderWidth: 1,
          },
        ],
      };
      return data;
    }

    getLoanData = (data) => {
      const count = [];
      const month = [];
      const amount = [];

      data.forEach((element) => {
        count.push(element.count);
        month.push(element.month);
        amount.push(element.amount);
      });

      return { count, month, amount };
    };

    fetchReport = async (year) => {
      try {
        const client = await AxiosClient();
        const response = await client.get(`business/report/chart/${year}`);

        const records = response.data.data;

        const total_loan_count = records.filter((x) => x.category === 'total_loan_count');
        const total_loan_amount_paid = records.filter((x) => x.category === 'total_loan_amount_paid');
        const total_past_due_amount = records.filter((x) => x.category === 'total_past_due_amount');
        const No_of_borrower = records.filter((x) => x.category === 'No_of_borrower');
        const total_amount_deposit = records.filter((x) => x.category === 'total_amount_deposit');

        const _loanCount = this.getLoanData(total_loan_count);
        const loanAmount = this.getChartData(_loanCount.amount, _loanCount.month, 'Disbursement(Value) Per Month');
        const loanCount = this.getChartData(_loanCount.count, _loanCount.month, 'Disbursement(Count) Per Month');

        const _loanCountPaid = this.getLoanData(total_loan_amount_paid);
        const loanAmountPaid = this.getChartData(_loanCountPaid.amount, _loanCountPaid.month, 'Re-Payment(Value) Per Month');
        const loanCountPaid = this.getChartData(_loanCountPaid.count, _loanCountPaid.month, 'Re-Payment(Count) Per Month');

        const _loanCountPastDue = this.getLoanData(total_past_due_amount);
        const loanAmountPastDue = this.getChartData(_loanCountPastDue.amount, _loanCountPastDue.month, 'PastDue(Value) Per Month');
        const loanCountPastDue = this.getChartData(_loanCountPastDue.count, _loanCountPastDue.month, 'PastDue(Count) Per month');

        const _Borrower = this.getLoanData(No_of_borrower);
        const loanCountBorrower = this.getChartData(_Borrower.count, _Borrower.month, 'Disbursement(Customers) Per month');

        const _wallet_deposit = this.getLoanData(total_amount_deposit);

        const walletdeposit = this.getChartData(_wallet_deposit.amount, _wallet_deposit.month, 'Wallet Topup Per Month');

        this.setState({
          loanAmount,
          loanCount,
          loanAmountPaid,
          loanCountPaid,
          loanAmountPastDue,
          loanCountPastDue,
          loanCountBorrower,
          walletdeposit,
        });
      } catch (error) {
        toast.error(error.response?.data?.message || error.response?.statusText);
      }
    };

    fetchReportPie = async (year) => {
      try {
        const client = await AxiosClient();
        const response = await client.get(`business/report/chart/pie/${year}`);

        const records = response.data.data;

        const loanCount = [records[0]?.total_running_loan, records[0]?.total_settled_loan,
          records[0]?.total_due_loan];
        const loanAmount = [records[0]?.total_running_amount, records[0]?.total_settled_amount,
          records[0]?.total_due_amount];

        const loanCountPie = this.getChartData(loanCount, ['No Running', 'No Settled', 'No Past Due'], 'Number of Loans By Status');
        const loanAmountPie = this.getChartData(loanAmount, ['Amount Running', 'Amount Settled', 'Amount Past Due'], 'Amount of Loans By Status');

        this.setState({ loanCountPie, loanAmountPie });
      } catch (error) {
        toast.error(error.response?.data?.message || error.response?.statusText);
      }
    };

    showYears = async () => {
      const data = [];
      const startYear = 2020;
      const endYear = new Date().getFullYear();
      for (let i = endYear; i > startYear; i -= 1) {
        data.push(i);
      }
      this.setState({ analysisYear: data });
    }

    handleOnYearChange = (e) => {
      toast.info('Fetching record');
      this.fetchReport(e.target.value);
      this.fetchReportPie(e.target.value);
    };

    render() {
      const {
        options, loanAmount, loanCount, loanAmountPaid, loanCountPaid, loanAmountPastDue,
        loanCountPastDue, loanCountBorrower, walletdeposit,
        loanCountPie, loanAmountPie, analysisYear,
      } = this.state;
      return (
        <>
          <SideNav page="analysis" />
          <main className="body-main">
            <div className="body-main__container">
              <TopNav page="analysis" />
              <section className="body-main__content">
                <div className="home">
                  <div className="pageTitle d-lg-none">
                    <h3 className="pageTitle__header">Hello,&nbsp;</h3>
                    <p className="pageTitle__subheader">Welcome back!</p>
                  </div>
                  <div className="row">
                    <div className="col-md-11"></div>
                    <div className="col-md-1">
                      <label>Select year</label>
                      <select className="form-control" onChange={this.handleOnYearChange}>
                        {analysisYear.map((x) => <option key={x} value={x}>{x}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Bar data={walletdeposit} options={options} height="200" />
                    </div>
                    <div className="col-md-6">
                      <Bar data={loanCountBorrower} options={options} height="200" />
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: '40px' }}>
                    <div className="col-md-6">
                      <Bar data={loanCount} options={options} height="200" />
                    </div>
                    <div className="col-md-6">
                      <Line data={loanAmount} options={options} height="200" />
                    </div>
                  </div>

                  <div className="row" style={{ marginTop: '40px' }}>
                    <div className="col-md-6">
                      <Bar data={loanCountPaid} options={options} height="200" />
                    </div>
                    <div className="col-md-6">
                      <Line data={loanAmountPaid} options={options} height="200" />
                    </div>
                  </div>

                  <div className="row" style={{ marginTop: '40px' }}>
                    <div className="col-md-6">
                      <Bar data={loanCountPastDue} options={options} height="200" />
                    </div>
                    <div className="col-md-6">
                      <Line data={loanAmountPastDue} options={options} height="200" />
                    </div>
                  </div>

                  <div className="row" style={{ marginTop: '40px' }}>
                    <div className="col-md-6">
                      <h4>Loans(Count) By Status</h4>
                      <Pie data={loanCountPie} height="100" />
                    </div>
                    <div className="col-md-6">
                      <h4>Loans(Value) By Status</h4>
                      <Pie data={loanAmountPie} height="100" />
                    </div>
                  </div>

                </div>
              </section>
            </div>
          </main>
        </>
      );
    }
}

export default Analysis;
